define([
    'santa-components',
    'lodash',
    'skins',
    'pinterestFollow/skins/skins.json',
    'componentsCore'
], function (santaComponents, _, skinsPackage, skinsJson, componentsCore) {
    'use strict';

    const getPinterestUrl = function (urlChoice) {
        const protocols = ['https://', 'http://', '//'];
        const hasProtocol = _.some(protocols, _.includes.bind(null, urlChoice));
        return hasProtocol ? urlChoice : _.last(protocols) + urlChoice;
    };

    /**
     * @class components.PinterestFollow
     * @extends {core.skinBasedComp}
     */
    const pinterestFollow = {
        displayName: 'PinterestFollow',
        mixins: [componentsCore.mixins.skinBasedComp],

        propTypes: {
            compData: santaComponents.santaTypesDefinitions.Component.compData.isRequired
        },

        getSkinProperties() {
            return {
                '': {
                    style: {
                        width: '',
                        height: ''
                    }
                },
                followButtonTag: {
                    children: [this.props.compData.label],
                    style: {'display': 'inline-block'}
                },
                followButton: {
                    href: getPinterestUrl(this.props.compData.urlChoice),
                    target: '_blank',
                    title: this.props.compData.label,
                    'aria-label': this.props.compData.label
                }
            };
        }
    };

    componentsCore.compRegistrar.register('wysiwyg.viewer.components.PinterestFollow', pinterestFollow);
    skinsPackage.skinsMap.addBatch(skinsJson);

    return pinterestFollow;
});
